var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 2C4.89543 2 4 2.90622 4 4.0241V19.9759C4 21.0938 4.89543 22 6 22H19C19.5523 22 20 21.5469 20 20.988V6.80723C20 6.33565 19.6813 5.93941 19.25 5.82706V3.51807C19.6642 3.51807 20 3.17824 20 2.75904C20 2.33983 19.6642 2 19.25 2H6ZM17.75 3.51807V5.79518H6.5C5.94772 5.79518 5.5 5.34747 5.5 4.79518V4.53012C5.5 3.97118 5.94772 3.51807 6.5 3.51807H17.75ZM12.75 9V11.25H15C15.4142 11.25 15.75 11.5858 15.75 12C15.75 12.4142 15.4142 12.75 15 12.75H12.75V19C12.75 19.4142 12.4142 19.75 12 19.75C11.5858 19.75 11.25 19.4142 11.25 19V12.75H9C8.58579 12.75 8.25 12.4142 8.25 12C8.25 11.5858 8.58579 11.25 9 11.25H11.25V9C11.25 8.58579 11.5858 8.25 12 8.25C12.4142 8.25 12.75 8.58579 12.75 9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBible);
export default __webpack_public_path__ + "static/media/bible.8d76efcc6aededf2a7b43f5aa5513eb0.svg";
export { ForwardRef as ReactComponent };